import { render, staticRenderFns } from "./StartProject.vue?vue&type=template&id=444ec046&scoped=true&"
import script from "./StartProject.vue?vue&type=script&lang=js&"
export * from "./StartProject.vue?vue&type=script&lang=js&"
import style0 from "./StartProject.vue?vue&type=style&index=0&id=444ec046&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ec046",
  null
  
)

export default component.exports